import RestaurantsContainer from './RestaurantsContainer';
export default RestaurantsContainer;
